/** Delete a feed. */
export const feedDeleteSpec = {
    uri: '/t/[tenant]/feed/[feed]',
    method: 'DELETE',
};
